// src/slices/shiptrafic/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getAllShipTraffic = createAsyncThunk("shipTraffic/getAll", async (params = {}, { rejectWithValue }) => {
  try {
    const queryParams = { ...(params.page && { page: params.page }), ...(params.search && { search: params.search }), ...(params.unloadingPort && { unloadingPort: params.unloadingPort }), ...(params.type && { type: params.type }) };

    const query = new URLSearchParams(queryParams).toString();
    const url = query ? `${API_URL}/ship-traffic/all?${query}` : `${API_URL}/ship-traffic/all`;


    const response = await axios.get(url);



    return response.data;
  } catch (err) {

    return rejectWithValue(err.response?.data);
  }
});
export const filterShipTraffic = createAsyncThunk("shipTraffic/filter", async (params = {}, { rejectWithValue }) => {
  try {
    const query = new URLSearchParams(params).toString();


    const response = await axios.get(`${API_URL}/ship-traffic/filter?${query}`);


    return response.data;
  } catch (err) {

    return rejectWithValue(err.response?.data);
  }
});
